import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useTheme, useToast } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { APIS, SF_AUTH_MENU_LIST, SF_CO_TP_SRCH, URLS } from "@/tra/tancis/ptli/ptl/cotpauth/service/PtliCoTpService";
import { SG_ROLE_LANG_LIST } from "@/tra/tancis/ptli/ptl/role/services/PtliRoleService";
import { SG_ROLE_AUTH_CNCT_LIST } from "@/tra/tancis/ptli/ptl/roleauth/services/PtliRoleAuthService";
import { PTLI1016003Q } from "@/tra/tancis/ptli/ptl/roleauth/PTLI1016003Q";
import { PTLI1016004Q } from "@/tra/tancis/ptli/ptl/roleauth/PTLI1016004Q";
import { PTLI0924003Q } from "@/tra/tancis/ptli/usr/extauth/PTLI0924003Q";

/*
 * Custom Office User Role History Management List
 * !== 세관 사용자 권한 이력 목록 ==!
 */
export const PTLI1008013S = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { theme } = useTheme();
    const { t } = useTranslation();
    const langCodes = ["KO", "EN", "TZ"];

    useResource({ defaultSchema: [{ area: "comnCd", comnCd: "COM0052" }] });

    const form = {
        form_coTpSrch: useForm({ defaultSchema: SF_CO_TP_SRCH }),
    };

    const grid = {
        roleLangList: useGrid({ defaultSchema: SG_ROLE_LANG_LIST }),
        roleAuthList: useGrid({ defaultSchema: SG_ROLE_AUTH_CNCT_LIST }),
    };

    const fetch = {
        saveAuth: useFetch({
            api: () => {
                const data1 = form.form_coTpSrch.getValues();
                const data = Object.values(grid.roleAuthList.getData()); // <- ensures an array

                const payload = data.map((item: any) => ({
                    coTpCd: data1.coTpCd,
                    authId: item.authId,
                }));

                console.log("Payload to send:", payload); // Should be a proper array
                return APIS.saveCoTpAuth(payload);
            },
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062",
                    onConfirm: () => navigate(URLS.ptli1008008q),
                    close: false,
                });
            },
            onError: (error: any) =>
                modal.openModal({ content: error.response?.data?.errorMessage || "Request failed" }),
        }),
    };

    const render = {
        roleAuthList: {
            cell: {
                authRelaMenuCnt: (args: any) => {
                    const { rowValues, value } = args;
                    return (
                        <button
                            className="underline"
                            onClick={() => {
                                modal.openModal({
                                    draggable: true,
                                    size: "sm",
                                    content: <PTLI1016004Q authId={rowValues.authId} />,
                                });
                            }}
                        >
                            {value}
                        </button>
                    );
                },
            },
        },
    };

    const handler = {
        onGridAddBtnClick: () => {
            const modalCallback = (list: any[]) => {
                !comnUtils.isEmpty(list) && list.forEach((item: any) => grid.roleAuthList.addRow({ ...item }));
                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "xl",
                content: (
                    <PTLI0924003Q roleId={"new"} callback={modalCallback} roleAuthList={grid.roleAuthList.getData()} />
                ),
            });
        },
        onGridDelBtnClick: () => {
            if (!grid.roleAuthList.isChecked()) {
                modal.openModal({ content: "msg.ptl.00683" }); // Please select a destination to delete. !== 삭제대상을 선택하세요. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.roleAuthList.deleteRow("checkbox");
                },
            });
        },
        onSubmitBtnClick: () => {
            const formValues = form.form_coTpSrch.getValues();
            const data = grid.roleAuthList.getData();

            if (!formValues.coTpCd) {
                // coTpCd is missing, show modal
                // modal.openModal({ content: "msg.ptl.00742" }); // e.g., "Please select a coTpCd"
                modal.openModal({ content: "Please select a coTpCd" }); // e.g., "Please select a coTpCd"
                return;
            }

            if (data.length === 0) {
                modal.openModal({ content: "msg.ptl.00741" }); // There is no data to be stored and deleted. !== 저장 및 삭제 대상 데이터가 없습니다. ==!
                return;
            }

            modal.openModal({
                content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => fetch.saveAuth.fetch(),
            });
        },
    };

    useEffect(() => {}, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.form_coTpSrch.schema.coTpCd} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                <Layout.Button role={"gridDelete"} onClick={handler.onGridDelBtnClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                    <Group.Section>
                        <Grid {...grid.roleAuthList.grid} render={render.roleAuthList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout>
                <Layout.Left>
                    <Button role="list" onClick={() => navigate(URLS.ptli1008008q)} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"submit"} onClick={handler.onSubmitBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
